import { ActionReducerMap } from '@ngrx/store';
import * as fromUI from './shared/reducers/ui.reducer';
import * as fromAuth from './auth/auth.reducer';
import * as fromAddress from './shared/reducers/address.reducer';

import * as fromOrder from './shared/reducers/order.reducer';
import * as fromCommerce from './shared/reducers/commerce-public.reducer';
import * as fromCategoriesCommerce from './shared/reducers/commerce-category.reducer';
import * as fromProductsCommerce from './shared/reducers/commerce-product.reducer';
import * as fromListShopCommerce from './shared/reducers/commerce-list-shop.reducer';

// import * as fromVehicle from './admin-pages/vehicles/vehicles.reducer';
// import * as fromTypeVehicle from './admin-pages/settings/type-vehicle/type-vehicle.reducer';
// import * as fromSeasonCalendar from './admin-pages/season-calendar/season-calendar.reducer';
// import * as fromFilter from './admin-pages/settings/filter/filter.reducer';
// import * as fromSchedule from './admin-pages/settings/schedule/schedule.reducer';
// import * as fromFilterVehicle from './shared/reducers/filter-vehicles.reducer';
// import * as fromFilterModels from './shared/reducers/filter-models.reducer';



export interface AppState {
    ui: fromUI.State;
    auth: fromAuth.AuthState;
    order: fromOrder.OrderState;
    active_commerce: fromCommerce.commerceState;
    categories_commerce: fromCategoriesCommerce.categoriesCommerceState;
    products_commerce: fromProductsCommerce.productsCommerceState;
    address: fromAddress.AddressState;
    // list_shop: fromListShopCommerce.listShopCommerceState,

    // shared: fromShared.SharedState;
    // sections: fromSections.SectionState;
    // vehicle: fromVehicle.VehicleState;
    // season_calendar: fromSeasonCalendar.SeasonCalendarState;
    // type_vehicle: fromTypeVehicle.TypeVehicleState;
    // day_spaces: fromFilter.FilterDaySpaceState;
    // sleep_spaces: fromFilter.FilterSleepSpaceState;
    // schedule_pickup: fromSchedule.SchedulePickUpState;
    // schedule_dropoff: fromSchedule.ScheduleDropOffState;
    // filter_vehicles: fromFilterVehicle.FilterVehiclesState;
}

export const appReducers: ActionReducerMap<AppState> = {
    ui: fromUI.uiReducer,
    auth: fromAuth.authReducer,
    order: fromOrder.orderReducer,
    active_commerce: fromCommerce.commerceReducer,
    categories_commerce: fromCategoriesCommerce.categoriesCommerceReducer,
    products_commerce: fromProductsCommerce.productsCommerceReducer,
    address: fromAddress.addressReducer,
    // list_shop: fromListShopCommerce.listShopCommerceReducer,

    // shared: fromShared.sharedReducer,
    // sections: fromSections.sectionReducer,
    // vehicle: fromVehicle.vehicleReducer,
    // seasons: fromSeason.seasonReducer,
    // season_calendar: fromSeasonCalendar.seasonCalendarReducer,
    // type_vehicle: fromTypeVehicle.typeVehicleReducer,
    // day_spaces: fromFilter.filterDayReducer,
    // sleep_spaces: fromFilter.filterSleepReducer,
    // schedule_pickup: fromSchedule.schedulePickUpReducer,
    // schedule_dropoff: fromSchedule.scheduleDropOffReducer,
    // filter_vehicles: fromFilterVehicle.filterVehiclesReducer,
};

